import catalogApi from '../apis/swagup/catalog';
import formOrdersApi from '../apis/swagup/formOrders';
import gtm from '../utils/gtm';
import {
  CATALOG_API_CALL_START,
  CATALOG_API_CALL_SUCCESS,
  CATALOG_API_CALL_ERROR,
  CATALOG_INITIALIZE,
  CATALOG_LOAD,
  CATALOG_PURCHASE
} from './types';
import { refreshPrices } from './cart';

export const initializeCatalog = (isBulk, template = null) => async (dispatch, getState) => {
  let catalog = getState().catalog.items;

  dispatch({ type: CATALOG_INITIALIZE, payload: { isBulk } });

  if (!catalog)
    try {
      dispatch({ type: CATALOG_API_CALL_START });

      catalog = (await catalogApi.fetch()).results;

      dispatch({ type: CATALOG_API_CALL_SUCCESS });
    } catch (error) {
      dispatch({ type: CATALOG_API_CALL_ERROR, payload: error });
      throw error;
    }

  dispatch({ type: CATALOG_LOAD, payload: { catalog, template } });
  dispatch(refreshPrices());
};

export const submitOrder = (products, info, isBulk) => async dispatch => {
  try {
    dispatch({ type: CATALOG_API_CALL_START });

    const order = await formOrdersApi.submit(products, info, isBulk);
    gtm.submitCatalogForm(order);

    dispatch({ type: CATALOG_PURCHASE, payload: { order } });
    dispatch({ type: CATALOG_API_CALL_SUCCESS });
  } catch (error) {
    dispatch({ type: CATALOG_API_CALL_ERROR, payload: error });
    throw error;
  }
};
